














































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$} from '@/facade'
import {OrbitRemoveOwnerStep} from '@/enums/OrbitRemoveOwnerStep'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {NeoHelper} from '@/helpers/NeoHelper'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import OrbitRemoveOwnerConfirmStep from '@/components/orbit/OrbitRemoveOwnerConfirmStep.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'

@Component({
  computed: {
    OrbitRemoveOwnerStep() {
      return OrbitRemoveOwnerStep
    },
  },
  components: {
    OrbitRemoveOwnerConfirmStep,
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitRemoveOwnerModal extends Vue {
  @Prop({type: String, required: true}) ownerAddress!: string

  currentStep: OrbitRemoveOwnerStep = OrbitRemoveOwnerStep.WAITING_SIGNATURE
  transactionHash: string | null = null

  get isRemovingConnectedWallet(): boolean {
    return (
      !!this.ownerAddress && this.ownerAddress === $.walletAdapter.n3Address
    )
  }

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    const hasPermission = await OrbitHelper.checkWalletPermissions()
      .then(() => true)
      .catch(() => false)

    if (!hasPermission) {
      this.closeModal()
      return
    }

    if (this.isRemovingConnectedWallet) {
      this.currentStep = OrbitRemoveOwnerStep.CONFIRM_SELF_REMOVAL
      return
    }

    await this.removeOwner()
  }

  handleCancelSelfRemoval() {
    this.closeModal()
  }

  async handleConfirmSelfRemoval() {
    this.currentStep = OrbitRemoveOwnerStep.WAITING_SIGNATURE
    await this.removeOwner()
  }

  async removeOwner() {
    try {
      if (!this.ownerAddress) {
        throw new Error('Missing owner address')
      }

      const n3InvocationBuilder = getN3InvocationBuilder()
      const removeOrbitOwnerInvocation = n3InvocationBuilder.removeOrbitOwnerInvocation(
        {
          ownerAddress: this.ownerAddress,
        }
      )

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        removeOrbitOwnerInvocation
      )
      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitRemoveOwnerStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      this.currentStep = OrbitRemoveOwnerStep.REMOVED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }

    this.closeModal()
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitRemoveOwnerStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitRemoveOwnerStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitRemoveOwnerStep.WAITING_SIGNATURE
    this.$emit('close')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    if (!address) {
      this.closeModal()
      return
    }

    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
    })
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitRemoveOwnerStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitRemoveOwnerStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitRemoveOwnerStep.UNKNOWN_ERROR
  }
}
